import { render } from "./Bedankt.vue?vue&type=template&id=518c38e6&scoped=true"
import script from "./Bedankt.vue?vue&type=script&lang=js"
export * from "./Bedankt.vue?vue&type=script&lang=js"

import "./Bedankt.vue?vue&type=style&index=0&id=518c38e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518c38e6"]])

export default __exports__